import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const NPSModal = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-nps-modal', 'fixed inset-0 z-[9999]', className)}
    {...props}
  />
));
NPSModal.displayName = 'NPSModal';

const npsModalContentVariants = cva('w-[400px] max-w-[80vw] p-5 flex flex-col gap-5 rounded-l-lg bg-white shadow-md absolute right-0 top-11 transition-transform duration-400 ease-out', {
  variants: {
    state: {
      open: 'translate-x-0 animate-in',
      closed: 'translate-x-full'
    }
  },
  defaultVariants: {
    state: 'closed'
  }
});

const NPSModalContent = React.forwardRef(({ className, state, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-nps-modal-content', npsModalContentVariants({ state }), className)}
    {...props}
  />
));
NPSModalContent.displayName = 'NPSModalContent';

const NPSModalHeader = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-nps-modal-header', '', className)}
    {...props}
  />
));
NPSModalHeader.displayName = 'NPSModalHeader';

const NPSModalTitle = React.forwardRef(({ className, variant, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-nps-modal-title', 'mb-0 text-neutral-dark text-sm font-bold', className)}
    {...props}
  />
));
NPSModalTitle.displayName = 'NPSModalTitle';

const NPSModalBody = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-nps-modal-body', '', className)}
    {...props}
  />
));
NPSModalBody.displayName = 'NPSModalBody';

const NPSModalFooter = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-nps-modal-footer', 'flex items-center justify-between', className)}
    {...props}
  />
));
NPSModalFooter.displayName = 'NPSModalFooter';

const NPSModalSteps = React.forwardRef(({ className, variant, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-nps-modal-steps', 'text-neutral text-xs font-light', className)}
    {...props}
  />
));
NPSModalSteps.displayName = 'NPSModalSteps';

export { NPSModal, NPSModalContent, NPSModalHeader, NPSModalBody, NPSModalFooter, NPSModalTitle, NPSModalSteps };
